import { render, staticRenderFns } from "./HealthAccordion.vue?vue&type=template&id=4da8a421&scoped=true"
import script from "./HealthAccordion.vue?vue&type=script&lang=js"
export * from "./HealthAccordion.vue?vue&type=script&lang=js"
import style0 from "./HealthAccordion.vue?vue&type=style&index=0&id=4da8a421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da8a421",
  null
  
)

export default component.exports